import React from 'react'
import { Col, Row } from 'react-bootstrap'
import OrderList from './orderList.tsx';
import OrdersFilters from './ordersFilters.tsx';




const OrderSummary = () => {
    return (
        <>
            <Row>
                <Col xs={4} sm={4} md={3} lg={3} xl={2}  style={{ backgroundColor: '#fff' }}>
                    <OrdersFilters />
                </Col>
                <Col xs={8} sm={8} md={9} lg={9} xl={10}>
                    <OrderList />
                </Col>
            </Row>
        </>
    )
}

export default OrderSummary